import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

function Policy() {
  return (
    <>
      <Navbar />
      <div className="news-banner news-banner-policy">
        <p>Privacy Policy</p>
        <br />
        <h1>Privacy Policy - Cine Celebrate</h1>
        <p>Effective Date: 20/07/2025</p>
        <p>
          Website:{" "}
          <a
            href="https://www.cinecelebrate.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.cinecelebrate.com
          </a>
        </p>
      </div>
      <div className="policy-revamp">
        <div className="policy-revamp__intro">
          <p className="policy-revamp__eyebrow">Privacy Commitment</p>
          <h2>Your information should feel as protected as your celebration.</h2>
          <p>
            At Cine Celebrate, your privacy is our top priority. As India’s
            leading platform for private theater experiences, event bookings,
            and celebration spaces, we are committed to maintaining the highest
            standards of data privacy, digital security, and user transparency.
          </p>
          <p>
            This Privacy Policy outlines how we collect, use, protect, and
            disclose your information when you interact with our services
            through our website, mobile platforms, or offline channels.
          </p>
        </div>

        <ol className="policy-revamp__list">
          <li>
            <strong>Information We Collect</strong>
            <p>
              We collect both personally identifiable information (PII) and
              non-personal technical data to enhance your user experience,
              improve services, and deliver customizations for your celebration
              bookings.
            </p>
            <ul>
              <li>
                <b>Personal Information :</b> Collected during sign-up, booking,
                or customer support:
                <ul>
                  <li>• Full Name</li>
                  <li>• Contact Number</li>
                  <li>• Email Address</li>
                  <li>
                    • Billing & Payment Details (processed securely via trusted
                    payment gateways)
                  </li>
                  <li>
                    • Booking Details (date, time slot, event type, number of
                    guests)
                  </li>
                  <li>
                    • Custom Requests (decor themes, celebration type, food
                    preferences, add-ons)
                  </li>
                </ul>
              </li>
              <li>
                <b>Usage and Technical Data:</b> Automatically collected to
                optimize platform functionality:
                <ul>
                  <li>• IP Address & Geo-location</li>
                  <li>• Device & Browser Type</li>
                  <li>• Operating System</li>
                  <li>• Pages Viewed, Click Patterns, Session Duration</li>
                  <li>
                    • Referral Sources (e.g., Google search, Instagram,
                    WhatsApp)
                  </li>
                  <li>
                    • Cookies, Web Beacons, Pixels, and Similar Tracking
                    Technologies
                  </li>
                </ul>
              </li>
              <li>
                <b>Log Files:</b> Like many hosting providers, we use log files
                to monitor website activity and server performance. Log files
                may include:
                <ul>
                  <li>• IP addresses</li>
                  <li>• Browser type</li>
                  <li>• Internet Service Provider (ISP)</li>
                  <li>• Date and time stamps</li>
                  <li>• Referring/exit pages</li>
                  <li>• Number of clicks</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <strong>How We Use Your Information</strong>
            <p>
              Your information helps us create seamless, personalized, and
              secure private theater celebrations:
            </p>
            <ul>
              <li>
                Your information helps us create seamless, personalized, and
                secure private theater celebrations:
              </li>
              <li>
                • Manage and confirm bookings for movie nights, romantic dates,
                birthdays, anniversaries, or corporate events
              </li>
              <li>
                • Customize your experience with décor, photography, themes, and
                food options
              </li>
              <li>
                • Send updates, confirmations, reminder emails, and SMS/WhatsApp
                notifications
              </li>
              <li>
                • Monitor analytics and platform usage for service improvements
              </li>
              <li>
                • Comply with legal obligations, audit requirements, and
                customer dispute resolution
              </li>
            </ul>
          </li>
          <li>
            <strong>Information Sharing & Disclosure</strong>
            <p>
              We do not sell or rent your personal data. We only share it when
              necessary:
            </p>
            <ul>
              <li>
                We respect your privacy and do not sell your data. However, we
                may share your information in the following circumstances:
              </li>
              <ul>
                <li>
                  {" "}
                  • Payment Processors: Razorpay, PhonePe, etc., for secure
                  payment handling
                </li>
                <li>
                  • Event Partners: Caterers, photographers, decorators (only on
                  request)
                </li>
                <li>
                  • Marketing & Analytics: Google Analytics, Meta Pixel,
                  WhatsApp Business API
                </li>
                <li>
                  • Legal Compliance: When required by law or to protect our
                  rights and users
                </li>
              </ul>
            </ul>
          </li>
          <li>
            <strong>Data Protection & Security</strong>
            <ul>
              <li>
                We utilize SSL encryption, firewalls, role-based access, and
                secure server hosting to keep your data safe. While we follow
                best industry practices, no digital system is completely immune
                to risks.
                <br />
                <br />
                If you believe your data has been misused or breached,
                <br />
                <br />
                notify us immediately at info@cinecelebrate.com.
              </li>
            </ul>
          </li>
          <li>
            <strong>Your Rights and Choices</strong>
            <p>As a user, you retain full control over your personal data:</p>
            <ul>
              <li>• Access or Modify your personal details</li>
              <li>
                • Request Deletion of your data (unless retention is required by
                law)
              </li>
              <li>• Unsubscribe from promotional emails, WhatsApp, or SMS</li>
              <li>• Manage Cookies via your browser settings</li>
            </ul>
          </li>
          <li>
            <strong>Cookies and Tracking Technologies</strong>
            <p>We use first-party and third-party cookies to:</p>
            <ul>
              <li>• Store session preferences</li>
              <li>• Analyse traffic behaviour</li>
              <li>• Personalize content and offers</li>
              <li>• Enable retargeting ads (via Google Ads & Meta Ads)</li>
            </ul>
          </li>
          <li>
            <strong>Manage Your Cookie Settings</strong>
            <p>
              You can disable cookies in your browser. Here are helpful links:
            </p>
            <ul>
              <li>• Manage Cookies in Chrome</li>
              <li>• Manage Cookies in Firefox</li>
              <li>• Manage Cookies in Safari</li>
            </ul>
            <p>Disabling cookies may affect some features of the site.</p>
          </li>
          <li>
            <strong>Our Advertising Partners</strong>
            <p>
              We may work with advertising platforms for audience targeting and
              remarketing:
            </p>
            <ul>
              <li>• Google</li>
              <li>• Meta (Facebook & Instagram)</li>
              <li>• WhatsApp Business API</li>
            </ul>
            <p>
              These platforms may use cookies or tracking pixels. Please refer
              to their privacy policies for details.
            </p>
          </li>
          <li>
            <strong>Third-Party Links and Embedded Tools</strong>
            <p>Our platform may link to:</p>
            <ul>
              <li>• Instagram, YouTube, WhatsApp, Facebook</li>
              <li>
                • Razorpay, Google Pay, UPI apps These third-party sites have
                their own privacy practices, which we do not control. Please
                read their privacy policies before engaging with them.
              </li>
            </ul>
          </li>
          <li>
            <strong>Children’s Privacy</strong>
            <p>
              Our services are designed for individuals aged 13 years and above.
              We do not knowingly collect data from minors. If a child under 13
              has provided us data, contact us immediately — we will delete it
              as required under COPPA.
            </p>
          </li>
          <li>
            <strong>International Compliance – GDPR & CCPA</strong>
            <p>We comply with global privacy laws including:</p>
            <br />
            <b>For EU Residents (GDPR):</b>
            <ul>
              <li>• Right to access or correct your data</li>
              <li>• Right to restrict processing or request deletion</li>
              <li>• Right to data portability</li>
              <li>
                • Right to file a complaint with your Data Protection Authority
              </li>
            </ul>
            <br />
            <b>For California Residents (CCPA):</b>
            <ul>
              <li>
                • Right to know what personal data we collect and how we use it
              </li>
              <li>• Right to request deletion</li>
              <li>
                • Right to opt out of data selling (Note: we do not sell your
                data)
              </li>
            </ul>
            <br />
            <b>
              To make any privacy-related request, contact
              info@cinecelebrate.com
            </b>
          </li>
          <li>
            <strong>Updates to This Privacy Policy</strong>
            <ul>
              <li>
                We may revise this Privacy Policy to reflect updates in legal
                regulations, technology, or business practices. All changes will
                be posted with the new effective date. Please check back
                periodically.
              </li>
            </ul>
          </li>
          <li>
            <strong>Contact Us</strong>
            <ul>
              <li>
                If you have questions, feedback, or privacy-related concerns:
              </li>
              <ul>
                <li>• Email: cinecelebrateglobal@gmail.com</li>
                <li>• WhatsApp: +91-9643055509</li>
                <li>• Website: https://www.cinecelebrate.com</li>
              </ul>
            </ul>
          </li>
        </ol>

        <div className="policy-revamp__footer">
          <p className="policy-revamp__eyebrow">Final Note</p>
          <p>
          By using Cine Celebrate, you agree to this Privacy Policy and trust us
          with your data as we deliver magical, private theater experiences
          tailored just for you.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Policy;
